/**
 * Review loop card — wraps gate cards + consolidation for a single loop iteration.
 *
 * Composes: section.ts, gateCard.ts, consolidateCard.ts
 * CSS: styles/components/section.css, gate-card.css
 */

import { renderSection } from './section.js'
import { renderGateCard } from './gateCard.js'
import { renderConsolidateCard } from './consolidateCard.js'
import type { ReviewLoopProps } from '../../types/components.js'

/** Render a review loop card containing gate results + optional consolidation. */
export function renderReviewLoop(props: ReviewLoopProps): string {
  const isRejected = props.status === 'rejected'
  const titleColor = isRejected ? 'color:var(--err)' : 'color:var(--grn)'
  const badgeBg = isRejected
    ? 'background:var(--err-d);color:var(--err)'
    : 'background:var(--grn-d);color:var(--grn)'
  const badgeLabel = isRejected ? 'Rejected' : 'All Approved'

  const gatesHtml = props.gates.map((g) => renderGateCard(g)).join('')
  const consolHtml = props.consolidate ? renderConsolidateCard(props.consolidate) : ''

  return renderSection({
    title: `Loop ${props.loopNumber}`,
    titleHtml: `<span style="${titleColor}">Loop ${props.loopNumber}</span>`,
    badgeHtml: `<span style="${badgeBg};padding:1px 6px;border-radius:3px;font-family:var(--mono);font-size:10px">${badgeLabel}</span>`,
    content: gatesHtml + consolHtml,
    defaultOpen: props.defaultOpen,
  })
}
